(function () {
  var root = document.querySelector('[data-cd]');
  var cfgEl = document.querySelector('[data-cd-config]');
  if (!root || !cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
  var panel = root.querySelector('.cd__panel');
  var itemsEl = root.querySelector('[data-cd-items]');
  var emptyEl = root.querySelector('[data-cd-empty]');
  var footEl = root.querySelector('[data-cd-foot]');
  var shipEl = root.querySelector('[data-cd-ship]');
  var errEl = root.querySelector('[data-cd-error]');
  var attest = root.querySelector('[data-cd-attest]');
  var checkoutBtn = root.querySelector('[data-cd-checkout]');
  var hint = root.querySelector('[data-cd-hint]');
  var addonEl = root.querySelector('[data-cd-addon]');
  var lastFocus = null;
  var cart = null;

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = cfg.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.')).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function showError(msg) { errEl.textContent = msg; errEl.hidden = !msg; }

  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }
  function load() { return api((cfg.root || '/') + 'cart.js').then(render); }

  // ---------- dispatch cut-off ----------
  function zoned(d) {
    var p = new Intl.DateTimeFormat('en-US', { timeZone: cfg.tz || 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' }).formatToParts(d);
    var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
    return { ymd: o.year + '-' + o.month + '-' + o.day, wd: o.weekday, h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10) };
  }
  var holidays = (cfg.holidays || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
  function isShipDay(z) { return z.wd !== 'Sat' && z.wd !== 'Sun' && holidays.indexOf(z.ymd) === -1; }
  function cutoffText() {
    var now = new Date();
    var z = zoned(now);
    var cut = cfg.cutoffHour || 14;
    if (isShipDay(z) && (z.h < cut)) {
      var mins = (cut - z.h) * 60 - z.m;
      var hh = Math.floor(mins / 60), mm = mins % 60;
      return 'Order within <b>' + (hh ? hh + 'h ' : '') + mm + 'm</b> to ship today';
    }
    for (var i = 1; i <= 10; i++) {
      var d = new Date(now.getTime() + i * 86400000);
      var zd = zoned(d);
      if (isShipDay(zd)) {
        var label = i === 1 ? 'tomorrow' : new Intl.DateTimeFormat('en-US', { timeZone: cfg.tz || 'America/New_York', weekday: 'long' }).format(d);
        return 'Ships <b>' + label + '</b> (cut-off ' + (cut > 12 ? (cut - 12) + 'pm' : cut + 'am') + ' ET on business days)';
      }
    }
    return 'Ships on the next business day';
  }

  // ---------- render ----------
  function render(c) {
    cart = c;
    document.querySelectorAll('[data-cd-count], .cart-dot').forEach(function (el) { el.textContent = c.item_count; });
    var has = c.item_count > 0;
    emptyEl.hidden = has;
    footEl.hidden = !has;
    shipEl.hidden = !has || !cfg.threshold;
    showError('');

    if (cfg.threshold) {
      var left = cfg.threshold - c.total_price;
      var pct = Math.max(0, Math.min(100, Math.round(c.total_price * 100 / cfg.threshold)));
      shipEl.classList.toggle('is-free', left <= 0);
      shipEl.querySelector('[data-cd-ship-msg]').innerHTML = left > 0
        ? 'You\'re <b>' + money(left) + '</b> away from <b>free 2-day shipping</b>'
        : '<b>Free 2-day shipping</b> unlocked';
      var bar = shipEl.querySelector('[data-cd-bar]');
      bar.setAttribute('aria-valuenow', pct);
      bar.firstElementChild.style.width = pct + '%';
    }

    itemsEl.innerHTML = c.items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return '<span class="cd__pill">' + esc(o.value) + '</span>'; }).join('');
      var orig = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var image = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
      return '<div class="cd__line" data-key="' + esc(it.key) + '">' +
        '<a class="cd__thumb" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (image ? '<img src="' + esc(img(image, 160)) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a>' +
        '<div><a class="cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<div class="cd__pills">' + opts +
        '<span class="cd__qty"><button type="button" data-cd-step="-1" aria-label="Decrease quantity of ' + esc(it.product_title) + '">−</button>' +
        '<input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity of ' + esc(it.product_title) + '" data-cd-qty>' +
        '<button type="button" data-cd-step="1" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></span></div></div>' +
        '<div class="cd__price">' + orig + '<span>' + money(it.final_line_price) + '</span><button type="button" class="cd__rm" data-cd-remove>Remove</button></div>' +
        '</div>';
    }).join('');

    if (addonEl) {
      var inCart = c.items.some(function (it) { return String(it.variant_id) === String(cfg.addonVariant); });
      addonEl.hidden = !has || inCart;
    }

    root.querySelector('[data-cd-subtotal]').textContent = money(c.total_price);
    root.querySelector('[data-cd-checkout-total]').textContent = money(c.total_price);
    root.querySelector('[data-cd-cutoff]').innerHTML = cutoffText();
    syncCheckout();
  }

  function syncCheckout() {
    var ok = attest.checked && cart && cart.item_count > 0;
    checkoutBtn.disabled = !ok;
    hint.hidden = attest.checked;
  }

  function change(key, qty, line) {
    if (line) line.classList.add('is-busy');
    return api((cfg.root || '/') + 'cart/change.js', { id: key, quantity: qty }).then(render).catch(function (e) {
      if (line) line.classList.remove('is-busy');
      showError(e.message);
    });
  }

  // ---------- open / close ----------
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('cd-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); panel.focus(); });
  }
  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('cd-lock');
    setTimeout(function () { root.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    var line = e.target.closest('.cd__line');
    if (line && e.target.closest('[data-cd-step]')) {
      var input = line.querySelector('[data-cd-qty]');
      var q = Math.max(0, parseInt(input.value || '0', 10) + parseInt(e.target.closest('[data-cd-step]').getAttribute('data-cd-step'), 10));
      change(line.getAttribute('data-key'), q, line);
    } else if (line && e.target.closest('[data-cd-remove]')) {
      change(line.getAttribute('data-key'), 0, line);
    } else if (e.target.closest('[data-cd-addon-btn]')) {
      var btn = e.target.closest('[data-cd-addon-btn]');
      btn.disabled = true;
      api((cfg.root || '/') + 'cart/add.js', { items: [{ id: parseInt(addonEl.getAttribute('data-variant'), 10), quantity: 1 }] })
        .then(load).catch(function (er) { showError(er.message); }).then(function () { btn.disabled = false; });
    }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-cd-qty]')) {
      var line = e.target.closest('.cd__line');
      change(line.getAttribute('data-key'), Math.max(0, parseInt(e.target.value || '0', 10)), line);
    }
    if (e.target === attest) syncCheckout();
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])');
      f = [].filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Checkout: save the attestation on the order, then go to checkout
  checkoutBtn.addEventListener('click', function () {
    if (!attest.checked) { syncCheckout(); return; }
    checkoutBtn.disabled = true;
    var stamp = new Date().toISOString();
    api((cfg.root || '/') + 'cart/update.js', { attributes: { 'Research use attestation': 'Confirmed ' + stamp + ': ' + (cfg.attestText || '') } })
      .then(function () { window.location.href = (cfg.root || '/') + 'checkout'; })
      .catch(function (e) { showError(e.message); checkoutBtn.disabled = false; });
  });

  // Open from the header cart icon
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="' + (cfg.cartUrl || '/cart') + '"]');
    if (!a || root.contains(a) || document.body.classList.contains('template-cart')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
    load().catch(function (er) { showError(er.message); });
  });

  // Add-to-cart forms open the drawer instead of reloading
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    var btns = [].slice.call(document.querySelectorAll('button[type="submit"]')).filter(function (b) { return b.form === form; });
    var prev = btns.map(function (b) { return b.disabled; });
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    var fd = new FormData(form);
    fetch((cfg.root || '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add this item.'); return j; }); })
      .then(function () { open(); return load(); })
      .catch(function (er) { open(); load(); showError(er.message); })
      .then(function () { btns.forEach(function (b, i) { b.removeAttribute('aria-busy'); b.disabled = prev[i]; }); });
  });

  // keep cut-off fresh while open
  setInterval(function () { if (!root.hidden && cart) root.querySelector('[data-cd-cutoff]').innerHTML = cutoffText(); }, 30000);
})();
